import { Injectable, Injector, EventEmitter } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalModel } from "./global.model";
import { FileModel } from "./file.model";
import { PaletteModel } from "./palette.model";
import { SwatchModel } from "./swatch.model";
import { SwatchChangedEvent } from "../events/swatch.changed.event";
import { SaveEvent } from "../events/save.event";

declare var SystemPath: any;
// declare var _: any;
import * as _ from "underscore";
import { LocalStorageService } from "../local-storge.service";

/**
 * NOTE: we are using _.deepExtend, so if we add new properties to our models, for later versions, when the older version file loads,
 * properties will be merged with the new ones, and it should make backward compatibility a non issue. Just add new properties to the models
 */
@Injectable()
export class PalettesModel extends FileModel {
  data = {
    version: "1.0.1",
    activePaletteId: "1",
    palettes: [
      new PaletteModel({
        id: "1",
        customFieldValue1: "",
        customFieldValue2: "",
        customFieldValue3: "",
        activeSwatchId: "",
        swatches: [
          {
            id: "1",
            zcc: "",
            rgb: "#FFFFFF",
          },
        ],
        swatchCustomFieldLabel1: "",
        swatchCustomFieldLabel2: "",
        swatchCustomFieldLabel3: "",
        swatchCustomFieldLabel4: "",
        swatchCustomFieldLabel5: "",
      }),
    ],
  };
  selectedPalette: PaletteModel = new PaletteModel();
  selectedSwatch: SwatchModel = new SwatchModel();

  saveEvent: EventEmitter<any> = new EventEmitter();
  swatchChanged: EventEmitter<any> = new EventEmitter();
  swatchColorChanged: EventEmitter<any> = new EventEmitter();
  public fileName: any;
  constructor(
    public gm: GlobalModel,
    public filename: string,
    localStorageService: LocalStorageService
  ) {
    super(localStorageService);
    this.fileName = filename;
    this.init();
    // this.checkEmptyModal();
  }

  init(): void {
    // this.filePath = this.gm.csInterface.getSystemPath(SystemPath.USER_DATA);
    // this.fileName =  "zcdp.palettes.json";
    this.initialDataStr =
      '{"version":"1.0.1","activePaletteId":"1","palettes":[{"id":"1","customFieldValue1":"","customFieldValue2":"","customFieldValue3":"","activeSwatchId":"","swatches":[{"id":"1","zcc":"ZCC-3841","rgb":"#FF0000","rgbfull":"255,0,0","hslfull":"0,100,50","labfull":"53,80,67","cmykfull":"0,100,100,0","red1":"rgb(255,0,0)","red2":"rgb(255,0,0)","red3":"rgb(255,0,0)","green1":"rgb(255,10,0)","green2":"rgb(255,30,0)","green3":"rgb(255,50,0)","hue1":"#FF0098","hue2":"#FF004C","hue3":"#FF000F","hue4":"#FF0F00","hue5":"#FF4C00","hue6":"#FF9900","brightness1":"rgb(204,0,0)","brightness2":"rgb(229,0,0)","brightness3":"rgb(249,0,0)","brightness4":"rgb(255,5,5)","brightness5":"rgb(255,25,25)","brightness6":"rgb(255,50,50)","saturation1":"rgb(242,12,12)","saturation2":"rgb(248,6,6)","saturation3":"rgb(253,1,1)","saturation4":"rgb(255,0,0)","saturation5":"rgb(255,0,0)","saturation6":"rgb(255,0,0)","contrastingFontColor":"white","contrastingShadowColor":"rgba(255,255,255,0.5)","customFieldValue1":"","customFieldValue2":"","customFieldValue3":"","customFieldValue4":"","customFieldValue5":"","selected":true},{"id":"86f7a346-e64f-ad20-f0a2-be544077eac7","zcc":"ZCC-4001","rgb":"#FFAA00","rgbfull":"255,170,0","hslfull":"40,100,50","labfull":"76,21,80","cmykfull":"0,33,100,0","red1":"rgb(255,170,0)","red2":"rgb(255,170,0)","red3":"rgb(255,170,0)","green1":"rgb(255,180,0)","green2":"rgb(255,200,0)","green3":"rgb(255,220,0)","hue1":"#FF1000","hue2":"#FF5D00","hue3":"#FF9A00","hue4":"#FFB900","hue5":"#FFF600","hue6":"#BBFF00","brightness1":"rgb(204,136,0)","brightness2":"rgb(229,153,0)","brightness3":"rgb(249,166,0)","brightness4":"rgb(255,171,5)","brightness5":"rgb(255,178,25)","brightness6":"rgb(255,187,50)","saturation1":"rgb(242,165,12)","saturation2":"rgb(248,167,6)","saturation3":"rgb(253,169,1)","saturation4":"rgb(255,170,0)","saturation5":"rgb(255,170,0)","saturation6":"rgb(255,170,0)","contrastingFontColor":"black","contrastingShadowColor":"rgba(0,0,0,0.5)","customFieldValue1":"","customFieldValue2":"","customFieldValue3":"","customFieldValue4":"","customFieldValue5":"","selected":false},{"id":"be92261e-3950-7881-8007-b2a7843cb5f5","zcc":"ZCC-4081","rgb":"#FFFF00","rgbfull":"255,255,0","hslfull":"60,100,50","labfull":"97,-22,94","cmykfull":"0,0,100,0","red1":"rgb(255,255,0)","red2":"rgb(255,255,0)","red3":"rgb(255,255,0)","green1":"rgb(255,255,0)","green2":"rgb(255,255,0)","green3":"rgb(255,255,0)","hue1":"#FF6600","hue2":"#FFB200","hue3":"#FFEF00","hue4":"#EFFF00","hue5":"#B2FF00","hue6":"#65FF00","brightness1":"rgb(203,204,0)","brightness2":"rgb(229,229,0)","brightness3":"rgb(249,249,0)","brightness4":"rgb(254,255,5)","brightness5":"rgb(254,255,25)","brightness6":"rgb(254,255,50)","saturation1":"rgb(242,242,12)","saturation2":"rgb(248,248,6)","saturation3":"rgb(253,253,1)","saturation4":"rgb(254,255,0)","saturation5":"rgb(254,255,0)","saturation6":"rgb(254,255,0)","contrastingFontColor":"black","contrastingShadowColor":"rgba(0,0,0,0.5)","customFieldValue1":"","customFieldValue2":"","customFieldValue3":"","customFieldValue4":"","customFieldValue5":"","selected":false},{"id":"cf267429-525a-eed2-eeff-cfc0b360fd92","zcc":"ZCC-0241","rgb":"#00FF00","rgbfull":"0,255,0","hslfull":"120,100,50","labfull":"88,-86,83","cmykfull":"100,0,100,0","red1":"rgb(10,255,0)","red2":"rgb(30,255,0)","red3":"rgb(50,255,0)","green1":"rgb(0,255,0)","green2":"rgb(0,255,0)","green3":"rgb(0,255,0)","hue1":"#99FF00","hue2":"#4CFF00","hue3":"#0FFF00","hue4":"#00FF0F","hue5":"#00FF4C","hue6":"#00FF99","brightness1":"rgb(0,204,0)","brightness2":"rgb(0,229,0)","brightness3":"rgb(0,249,0)","brightness4":"rgb(5,255,5)","brightness5":"rgb(25,255,25)","brightness6":"rgb(50,255,50)","saturation1":"rgb(12,242,12)","saturation2":"rgb(6,248,6)","saturation3":"rgb(1,253,1)","saturation4":"rgb(0,255,0)","saturation5":"rgb(0,255,0)","saturation6":"rgb(0,255,0)","contrastingFontColor":"black","contrastingShadowColor":"rgba(0,0,0,0.5)","customFieldValue1":"","customFieldValue2":"","customFieldValue3":"","customFieldValue4":"","customFieldValue5":"","selected":false},{"id":"81cac46b-1d98-48f6-6dda-83f786bcced6","zcc":"ZCC-0016","rgb":"#0000FF","rgbfull":"0,0,255","hslfull":"240,100,50","labfull":"32,79,-108","cmykfull":"100,100,0,0","red1":"rgb(10,0,255)","red2":"rgb(30,0,255)","red3":"rgb(50,0,255)","green1":"rgb(0,10,255)","green2":"rgb(0,30,255)","green3":"rgb(0,50,255)","hue1":"#0099FF","hue2":"#004CFF","hue3":"#000FFF","hue4":"#0F00FF","hue5":"#4C00FF","hue6":"#9800FF","brightness1":"rgb(0,0,204)","brightness2":"rgb(0,0,229)","brightness3":"rgb(0,0,249)","brightness4":"rgb(5,5,255)","brightness5":"rgb(25,25,255)","brightness6":"rgb(50,50,255)","saturation1":"rgb(12,12,242)","saturation2":"rgb(6,6,248)","saturation3":"rgb(1,1,253)","saturation4":"rgb(0,0,255)","saturation5":"rgb(0,0,255)","saturation6":"rgb(0,0,255)","contrastingFontColor":"white","contrastingShadowColor":"rgba(255,255,255,0.5)","customFieldValue1":"","customFieldValue2":"","customFieldValue3":"","customFieldValue4":"","customFieldValue5":"","selected":false},{"id":"c581138d-3ee0-a108-f038-d1c9d23f905a","zcc":"ZCC-3856","rgb":"#FF00FF","rgbfull":"255,0,255","hslfull":"-60,100,50","labfull":"60,98,-61","cmykfull":"0,100,0,0","red1":"rgb(255,0,255)","red2":"rgb(255,0,255)","red3":"rgb(255,0,255)","green1":"rgb(255,10,255)","green2":"rgb(255,30,255)","green3":"rgb(255,50,255)","hue1":"#6600FF","hue2":"#B200FF","hue3":"#EF00FF","hue4":"#FF00EF","hue5":"#FF00B2","hue6":"#FF0066","brightness1":"rgb(204,0,203)","brightness2":"rgb(229,0,229)","brightness3":"rgb(249,0,249)","brightness4":"rgb(255,5,254)","brightness5":"rgb(255,25,254)","brightness6":"rgb(255,50,254)","saturation1":"rgb(242,12,242)","saturation2":"rgb(248,6,248)","saturation3":"rgb(253,1,253)","saturation4":"rgb(255,0,254)","saturation5":"rgb(255,0,254)","saturation6":"rgb(255,0,254)","contrastingFontColor":"white","contrastingShadowColor":"rgba(255,255,255,0.5)","customFieldValue1":"","customFieldValue2":"","customFieldValue3":"","customFieldValue4":"","customFieldValue5":"","selected":false}],"swatchCustomFieldLabel1":"","swatchCustomFieldLabel2":"","swatchCustomFieldLabel3":"","swatchCustomFieldLabel4":"","swatchCustomFieldLabel5":""}]}';
    this.initFileCheck();
    this.selectedSwatch = this.selectedPalette.swatches[0];

    if (this.data && this.data.palettes && this.data.palettes.length) {
      for (var i = 0; i < this.data.palettes.length; i++) {
        this.data.palettes[i] = new PaletteModel(this.data.palettes[i]);
      }

      if (this.data.activePaletteId !== "") {
        for (var i = 0; i < this.data.palettes.length; i++) {
          //console.log('this.data.palettes[i].id', this.data.palettes[i].id);
          // if ( this.data.palettes[i].id == this.data.activePaletteId ) {
          this.selectedPalette = this.data.palettes[i];
          this.selectedSwatch = this.data.palettes[i].swatches[0];
          break;
          // }
        }

        if (this.selectedPalette.swatches.length) {
          this.selectedSwatch = this.selectedPalette.swatches[0];
        }
      } else {
        this.selectedPalette = this.data.palettes[0];
        this.data.activePaletteId = this.selectedPalette.id;
      }

      if (this.selectedPalette && this.selectedPalette.swatches.length) {
        var temp = _.findWhere(this.selectedPalette.swatches, {
          selected: true,
        });
        if (temp != undefined) {
          this.selectedSwatch = temp;
        } else {
          this.selectedSwatch = this.selectedPalette.swatches[0];
        }
      }

      this.data.activePaletteId = this.selectedPalette.id;

      var o = new SwatchChangedEvent({
        oldSwatchId: undefined,
        oldPaletteId: undefined,
        newSwatch: this.selectedSwatch,
        newPalette: this.selectedPalette,
      });

      this.swatchChanged.emit(o);
    }
  }

  isEmpty() {
    let empty = true;
    for (var i = 0; i < this.selectedPalette.swatches.length; i++) {
      if (!this.selectedPalette.swatches[i].empty) {
        empty = false;
        break;
      }
    }
    return empty;
  }
  removePalette(pal: PaletteModel) {
    var removedId = "";

    for (var i = 0; i < this.data.palettes.length; i++) {
      if (this.data.palettes[i].id === pal.id) {
        removedId = pal.id;
        this.data.palettes.splice(i, 1);
      }
    }

    if (this.data.palettes.length === 0) {
      // oh, snap! no more palettes

      var pal = new PaletteModel({}); // TODO: this the right way
      this.data.palettes.push(pal);
      this.selectedPalette = pal;
      this.data.activePaletteId = this.selectedPalette.id;
      this.selectedSwatch = pal.swatches[0];
      this.selectedSwatch.selected = true;

      var o = new SwatchChangedEvent({
        oldSwatchId: undefined,
        oldPaletteId: undefined,
        newSwatch: this.selectedSwatch,
        newPalette: this.selectedPalette,
      });

      this.swatchChanged.emit(o);
    } else {
      if (this.selectedPalette.id === removedId) {
        // how is this not true?
        this.selectedPalette = this.data.palettes[0];
        this.data.activePaletteId = this.selectedPalette.id;
        this.selectedSwatch = this.data.palettes[0].swatches[0];
        this.data.palettes[0].swatches[0].selected = true;

        var o = new SwatchChangedEvent({
          oldSwatchId: undefined,
          oldPaletteId: undefined,
          newSwatch: this.selectedSwatch,
          newPalette: this.selectedPalette,
        });

        this.swatchChanged.emit(o);
      }
    }

    this.gm.palettesModel.writeDefaultFile();
  }

  createPalette(swatches, selectIndex): PaletteModel {
    var pal = new PaletteModel({});

    if (swatches) pal.swatches = swatches;

    this.data.palettes.unshift(pal);
    this.selectedPalette = pal;
    this.data.activePaletteId = this.selectedPalette.id;
    this.selectedSwatch = pal.swatches[selectIndex];

    //For Each Palette
    for (var i = 0; i < this.data.palettes.length; i++) {
      //Loop through each swatch in the palette
      for (var o = 0; o < this.data.palettes[i].swatches.length; o++) {
        this.data.palettes[i].swatches[o].selected = false;
      }
    }

    this.selectedSwatch.selected = true;

    this.swatchChanged.emit(
      new SwatchChangedEvent({
        oldSwatchId: undefined,
        oldPaletteId: undefined,
        newSwatch: this.selectedSwatch,
        newPalette: this.selectedPalette,
      })
    );

    this.gm.palettesModel.writeDefaultFile();
    return pal;
  }

  updatePalette(pal): PaletteModel {
    for (var i = 0; i < this.data.palettes.length; i++) {
      if (this.data.palettes[i].id === pal.id) {
        let swatches = this.data.palettes[i].swatches;
        swatches.forEach((element) => {
          element.selected = false;
        });
        this.selectedSwatch = this.data.palettes[i].swatches[0];
        this.data.palettes[i].swatches[0].selected = true;
        break;
      }
    }
    var o = new SwatchChangedEvent({
      oldSwatchId: undefined,
      oldPaletteId: undefined,
      newSwatch: this.selectedSwatch,
      newPalette: this.selectedPalette,
    });
    this.swatchChanged.emit(o);
    this.gm.palettesModel.writeDefaultFile();
    return pal;
  }

  updatePaletteWithoutSelectingSwatch(pal): PaletteModel {
    for (var i = 0; i < this.data.palettes.length; i++) {
      if (this.data.palettes[i].id === pal.id) {
        let swatches = this.data.palettes[i].swatches;
        swatches.forEach((element) => {
          element.selected = false;
        });
        // this.selectedSwatch = this.data.palettes[i].swatches[0];
        // this.data.palettes[i].swatches[0].selected = true;
        break;
      }
    }
    var o = new SwatchChangedEvent({
      oldSwatchId: undefined,
      oldPaletteId: undefined,
      newSwatch: this.selectedSwatch,
      newPalette: this.selectedPalette,
    });
    this.swatchChanged.emit(o);
    this.gm.palettesModel.writeDefaultFile();
    return pal;
  }
}
